import { config } from '@/configs/env.config'

export enum Permissions {
  LOGIN_AS = 'login-as',
  MANAGE_EPILOT_IDP = 'manage-epilot-idp',
  MANAGE_PHONE = 'manage-phone',
  EDIT_USER_EMAIL = 'edit-user-email',
  EDIT_ORG_SETTINGS = 'edit-org-settings',
  DELETE_ORG = 'delete-org',
  CREATE_PREVIEW_ORG = 'create-preview-org',
  DELETE_USER = 'delete-user',
  VLINK_ADMIN = 'vlink-admin',
  VIEW_ANNOUNCEMENTS = 'view-announcements',
  MANAGE_ANNOUNCEMENTS = 'manage-announcements'
}

enum Groups {
  EMPLOYEE = 'employee',
  MANAGER = 'manager',
  ADMIN = 'admin',
  SUPER_ADMIN = 'super-admin',
  VLINK_ADMIN = 'vlink-admin'
}

const permissions: { [key: string]: string[] } = {
  [Permissions.MANAGE_EPILOT_IDP]: [Groups.ADMIN, Groups.SUPER_ADMIN],
  // same groups phone-integration-api's operator API admits
  [Permissions.MANAGE_PHONE]: [Groups.ADMIN, Groups.SUPER_ADMIN],
  [Permissions.LOGIN_AS]: [Groups.ADMIN, Groups.MANAGER, Groups.SUPER_ADMIN],
  [Permissions.EDIT_ORG_SETTINGS]: [Groups.ADMIN, Groups.SUPER_ADMIN],
  [Permissions.DELETE_ORG]: [Groups.SUPER_ADMIN],
  // a preview org is a full copy of the source org's configuration
  [Permissions.CREATE_PREVIEW_ORG]: [Groups.ADMIN, Groups.SUPER_ADMIN],
  [Permissions.EDIT_USER_EMAIL]: [Groups.SUPER_ADMIN],
  [Permissions.DELETE_USER]: [Groups.SUPER_ADMIN],
  [Permissions.VLINK_ADMIN]: [Groups.VLINK_ADMIN],
  [Permissions.VIEW_ANNOUNCEMENTS]: [
    Groups.EMPLOYEE,
    Groups.MANAGER,
    Groups.ADMIN,
    Groups.SUPER_ADMIN,
    Groups.VLINK_ADMIN
  ],
  // publishing sends a banner to every customer org -> admins only
  [Permissions.MANAGE_ANNOUNCEMENTS]: [Groups.ADMIN, Groups.SUPER_ADMIN]
}

export const isPermitted = (permission: string, user: any) => {
  // Allow LOGIN_AS for all logged-in users on non-production environments
  if (permission === Permissions.LOGIN_AS && config.STAGE !== 'prod') {
    return true
  }

  const userGroups: string[] =
    user.signInUserSession.accessToken.payload['cognito:groups'] ?? []

  return userGroups.some((group) => permissions[permission].includes(group))
}
